"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array-buffer.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.typed-array.uint8-array");

require("core-js/modules/es.typed-array.copy-within");

require("core-js/modules/es.typed-array.every");

require("core-js/modules/es.typed-array.fill");

require("core-js/modules/es.typed-array.filter");

require("core-js/modules/es.typed-array.find");

require("core-js/modules/es.typed-array.find-index");

require("core-js/modules/es.typed-array.for-each");

require("core-js/modules/es.typed-array.includes");

require("core-js/modules/es.typed-array.index-of");

require("core-js/modules/es.typed-array.iterator");

require("core-js/modules/es.typed-array.join");

require("core-js/modules/es.typed-array.last-index-of");

require("core-js/modules/es.typed-array.map");

require("core-js/modules/es.typed-array.reduce");

require("core-js/modules/es.typed-array.reduce-right");

require("core-js/modules/es.typed-array.reverse");

require("core-js/modules/es.typed-array.set");

require("core-js/modules/es.typed-array.slice");

require("core-js/modules/es.typed-array.some");

require("core-js/modules/es.typed-array.sort");

require("core-js/modules/es.typed-array.subarray");

require("core-js/modules/es.typed-array.to-locale-string");

require("core-js/modules/es.typed-array.to-string");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _constants = require("../constants");

var _lodash = _interopRequireDefault(require("lodash"));

var _exifJs = require("exif-js");

var _uploader = _interopRequireDefault(require("./uploader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var base64ToArrayBuffer = function base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data:([^;]+);base64,/gim, '');
  var binaryString = atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);

  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
};

var formatBytes = function formatBytes(bytes) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (0 === bytes) {
    return '0 Bytes';
  }

  var c = 1024;
  var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var f = Math.floor(Math.log(bytes) / Math.log(c));
  return parseFloat((bytes / Math.pow(c, f)).toFixed(decimal)) + ' ' + e[f];
};

var File = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(File, _PureComponent);

  var _super = _createSuper(File);

  function File(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, File);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.readFile = _this.readFile.bind((0, _assertThisInitialized2["default"])(_this));
    _this.readMultipleFiles = _this.readMultipleFiles.bind((0, _assertThisInitialized2["default"])(_this));
    _this.hasExtension = _this.hasExtension.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(File, [{
    key: "hasExtension",
    value: function hasExtension(fileName) {
      return new RegExp('(' + this.props.imgExtension.join('|').replace(/\./g, '\\.') + ')$').test(fileName.toLowerCase());
    }
  }, {
    key: "readFile",
    value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function (evt) {
          // console.log('Just read', file.name);
          resolve(evt.target.result);
        };

        reader.onerror = function (err) {
          console.error('Failed to read', file.name, 'due to', err);
          reject(err);
        };

        reader.readAsDataURL(file);
      });
    }
  }, {
    key: "readMultipleFiles",
    value: function readMultipleFiles(_ref) {
      var _this2 = this;

      var files = _ref.files,
          errors = _ref.errors;
      var results = [];
      var err = (0, _toConsumableArray2["default"])(errors);

      var promises = _lodash["default"].map(files, function (file) {
        // Check for file extension
        if (!_this2.hasExtension(file.name)) {
          err = [].concat((0, _toConsumableArray2["default"])(err), ["File ".concat(file.name, " not uploaded due to file type. Please check that your photo is in ").concat(_this2.props.imgExtension.join(', '), " format, and try again.")]);
          return undefined;
        } else if (file.size > parseInt(_this2.props.maxFileSize, 10)) {
          // Check for file size
          err = [].concat((0, _toConsumableArray2["default"])(err), ["File ".concat(file.name, " not uploaded due to size. Please check that your photo is under ").concat(formatBytes(parseInt(_this2.props.maxFileSize, 10) * 0.75), " and try again.")]);
          return undefined;
        } else {
          return _this2.readFile(file).then(function (base64) {
            var exif = _exifJs.EXIF.readFromBinaryFile(base64ToArrayBuffer(base64));

            results.push(_objectSpread(_objectSpread({
              file: file
            }, _this2.props.config), {}, {
              name: file.name,
              lastModifiedDate: file.lastModifiedDate,
              lastModified: file.lastModified,
              uploadDate: new Date(),
              base64: base64,
              exif: exif
            }));
          });
        }
      });

      return Promise.all(promises).then(function () {
        console.log('Done processing');
        return {
          results: results,
          errors: err
        };
      });
    }
  }, {
    key: "onChange",
    value: function onChange(results) {
      this.props.input.onBlur();
      this.props.input.onChange(results);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_uploader["default"], (0, _extends2["default"])({}, this.props, this.props.config, {
        readFile: this.readFile,
        readMultipleFiles: this.readMultipleFiles,
        onChange: this.onChange
      }));
    }
  }]);
  return File;
}(_react.PureComponent);

File.defaultProps = {
  buttonStyle: "achievement_text",
  withPreview: false,
  accept: 'image/*',
  // only allowing images, no pdf
  name: '',
  withIcon: true,
  buttonText: 'Choose Images',
  label: undefined,
  imgExtension: ['.jpg', '.jpeg', '.gif', '.png'],
  maxFileSize: _constants.defaultMaxFileSize,
  maxFiles: _constants.defaultMaxFiles,
  fileSizeError: ' file size is too big',
  fileTypeError: ' is not supported file extension'
};
File.propTypes = {
  onChange: _propTypes.func.isRequired,
  withPreview: _propTypes.bool,
  buttonStyle: _propTypes.string,
  accept: _propTypes.string,
  name: _propTypes.string,
  buttonText: _propTypes.string,
  label: _propTypes.string,
  imgExtension: _propTypes.array,
  maxFileSize: _propTypes.number.isRequired,
  fileSizeError: _propTypes.string,
  fileTypeError: _propTypes.string,
  maxFiles: _propTypes.number.isRequired
};
var _default = File;
exports["default"] = _default;